import create from "zustand"

export const useGeneralStore = create((set) => ({
  modalTncDwpId: "modal-tnc-dwp",
  modalTncDwp: null,
  setModalTncDwp: (modalTncDwp) => set(() => ({ modalTncDwp })),
}))
